import Link from "../../../components/Link";
import { IListviewField } from "../../../services/types";
import { getCurrentUrlAsSource } from "../../../services/utils";
import { UserConventionPermissionFull } from "./types";
import { dispForm } from "./urls";

export const userName: IListviewField<UserConventionPermissionFull> = {
  title: "Benutzer",
  fieldName: "userName",
  isSortable: true,
  renderListValue: (item: UserConventionPermissionFull) => (
    <Link href={`${dispForm}/${item.user.id}?${getCurrentUrlAsSource()}`}>{item.user.name}</Link>
  ),
};

export const userKey: IListviewField<UserConventionPermissionFull> = {
  title: "Schlüssel",
  fieldName: "userKey",
  isSortable: true,
  renderListValue: (item: UserConventionPermissionFull) => item.user.key,
};
